import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import Tooltip from '@tippyjs/react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import EditItemMasterService from "../../../services/itemmaster/itemmasterEditServices";

function ItemmasterView() {

    const [itemid, setItemID] = useState("")
    const [itemname, setItemName] = useState("")
    const [serial_numbers, setSerial_numbers] = useState([])
    const [description, setDescription] = useState("")
    const [life_in_months, setLife_in_Months] = useState("")
    const [netbookvalue, setNetBoolValue] = useState("")
    const [originalcost, setOriginal_Cost] = useState("")
    const [date_place, setDate_place] = useState(null)
    const [year, setYear] = useState(null);
    const [make, setMake] = useState(null);
    const [model, setModel] = useState(null);
    const [manufacturer, setManufacturer] = useState(null);
    const [status, setStatus] = useState("")
    const [category, setCategory] = useState("")
    const [sub_category, setSub_category] = useState("")
    const [contract_number, setContractNumber] = useState("")
    const [asset_number, setAsset_number] = useState("")
    const [loading, setLoading] = useState(true)
    const [contract_id, setContract_id] = useState("")
    const [contract_status, setContract_status] = useState("")
    const [contract_type, setContract_type] = useState("")
    const [asset_id, setAsset_id] = useState("")
    const [item_type, setItem_type] = useState("")

    const { state } = useLocation();
    let navigate = useNavigate();


    useEffect(() => {
        EditItemMasterService.getItemmaster(state).then(
            (response) => {
                setItemID(response.data.itemid)
                setItemName(response.data.itemname)
                setSerial_numbers(response.data.serial_numbers || [])
                setDescription(response.data.description)
                setNetBoolValue(response.data.netbookvalue)
                setLife_in_Months(response.data.lifeinmonths)
                setOriginal_Cost(response.data.originalcost)
                setYear(response.data.yearofmanufacture)
                setMake(response.data.make)
                setModel(response.data.model)
                setManufacturer(response.data.manufacturer)
                setDate_place(response.data.dateplacedinservice)
                setStatus(response.data.status)
                setContractNumber(response.data.contract_number)
                setAsset_number(response.data.asset_number)
                setAsset_id(response.data.asset_id)
                setContract_id(response.data.contract_id)
                setContract_status(response.data.contractstatus)
                setContract_type(response.data.contract_status)
                setItem_type(response.data.item_type)
                setCategory(response.data.category_name)
                setSub_category(response.data.sub_category_name)
                setLoading(false)
            }
        )
    }, [])

    const handleViewRedirect = (id, status, contract_type) => {
        if (status === "Active" || status === "PaidOff") {
            navigate("/contract/view", { state: id });
        } else if (status === "Terminated") {
            navigate("/contract/view", { state: id });
        } else {
            if (contract_type === "Loan") {
                navigate("/editloancontract", { state: id });
            } else if (contract_type === "Rental") {
                navigate("/editrentalcontract", { state: id });
            } else {
                navigate("/contract/edit", { state: id });
            }
        }
    };

    const handleAssetView = (contract_id, conractstatus, contracttype, asset_id) => {
        if (conractstatus === "Active" || conractstatus === "PaidOff") {
            navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id })
        } else if (conractstatus === "Terminated") {
            navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id })
        } else {
            if (contracttype === "Loan") {
                navigate(`/editloancontract?Asset=${asset_id}`, { state: contract_id });
            } else if (contracttype === "Rental") {
                navigate(`/editrentalcontract?Asset=${asset_id}`, { state: contract_id });
            } else {
                navigate(`/contract/edit?Asset=${asset_id}`, { state: contract_id });
            }
        }
    }

    return (
        <>
            <div className="container-fluid">
                {
                    loading === false ? (
                        <>
                            <div className="header pb-0 ">
                                <div className="d-lg-flex pt-2">
                                    <div>
                                        <h5>{t('Inventory Details')}</h5>
                                        <h6>
                                            <Link to="/itemmaster" className="tc">{t("Inventory")}</Link> / <span>{t("View Inventory")}</span>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="card ">
                                <div className="card-body">
                                    <div className="col-md-12">
                                        {/* Header Section */}
                                        <div className="row">
                                            {/* Item Number */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Item Number')} <Tooltip content={t("ItemNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {itemname ? itemname : "None"}
                                                </span>
                                            </div>
                                            {/* Description */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Description')} <Tooltip content={t("Description_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {description ? description : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Serial Number */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Serial Number')} <Tooltip content={t("Serialnumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {serial_numbers.length > 0 ? serial_numbers.map((row) => row.serial_number).filter(Boolean).join(", ") : "None"}
                                                </span>
                                            </div>
                                            {/* Item Type */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Item Type')} <Tooltip content={t("itemtype_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {item_type ? item_type : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Category */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Category')} <Tooltip content={t("Category_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {category ? category : "None"}
                                                </span>
                                            </div>
                                            {/* Sub Category */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Sub Category')} <Tooltip content={t("Sub_category_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {sub_category ? sub_category : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Status */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Status')} <Tooltip content={t("Status_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {status}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Details Section */}
                            <div className="card" style={{ marginTop: '10px' }}>
                                <div className="card-body">
                                    <div className="col-md-12">
                                        <div className="row">
                                            {/* Contract Number */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Contract Number')} <Tooltip content={t("contractnumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span
                                                    className={`col-lg-8 view-label p ${contract_number ? 'hyperlink' : ''}`}
                                                    onClick={
                                                        contract_number
                                                            ? () => handleViewRedirect(
                                                                contract_id,
                                                                contract_status,
                                                                contract_type
                                                            )
                                                            : undefined
                                                    }
                                                >
                                                    {contract_number ? contract_number : "None"}
                                                </span>
                                            </div>
                                            {/* Asset Number */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Asset Number')} <Tooltip content={t("Assetnumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span
                                                    className={`col-lg-8 view-label p ${asset_number ? 'hyperlink' : ''}`}
                                                    onClick={
                                                        asset_number
                                                            ? () => handleAssetView(
                                                                contract_id,
                                                                contract_status,
                                                                contract_type,
                                                                asset_id
                                                            )
                                                            : undefined
                                                    }
                                                >
                                                    {asset_number ? asset_number : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Manufacturer */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Manufacturer')} <Tooltip content={t("Manufacturer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {manufacturer ? manufacturer : "None"}
                                                </span>
                                            </div>
                                            {/* Model */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Model')} <Tooltip content={t("Model_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {model ? model : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Make */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Make')} <Tooltip content={t("Make_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {make ? make : "None"}
                                                </span>
                                            </div>
                                            {/* Year of Manufacture */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Year of Manufacture')} <Tooltip content={t("YearofManufacturer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {year ? year : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Date Placed in Service */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Date placed in Service')} <Tooltip content={t("DateplacedinService_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {date_place ? Helper.DateNormal(date_place) : "None"}
                                                </span>
                                            </div>
                                            {/* Life in Months */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Life in Months')} <Tooltip content={t("LifeinMonths_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {life_in_months ? life_in_months : "None"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Net Book Value */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Net Book Value')} <Tooltip content={t("NetBookValue_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {netbookvalue ? Helper.Amount(netbookvalue) : "None"}
                                                </span>
                                            </div>
                                            {/* Original Cost */}
                                            <div className="col-xl-3">
                                                <label className="col-lg-12 col-form-label">{t('Original Cost')} <Tooltip content={t("OriginalCost_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                            </div>
                                            <div className="col-xl-3">
                                                <span className="col-lg-8 view-label p">
                                                    {originalcost ? Helper.Amount(originalcost) : "None"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <ContentLoader
                            viewBox="0 0 400 160"
                            backgroundColor="rgba(0,0,0,0.06)"
                            foregroundColor="rgba(0,0,0,0.12)"
                        >
                            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                        </ContentLoader>
                    )
                }
            </div>
        </>
    )
}

export default ItemmasterView
